import { useLanguage } from '../../i18n/LanguageContext';
import type { Credit } from '../../services/dealerApi';
import Money from './Money';
import StatusChip from './StatusChip';
import { formatDate } from '../../utils/dealer';

/** Spec 085 (Flow J step 3, BR-24) — credits this dealer requested or assigned: totals only, no order rows. */
export default function CreditSummaryTable({ credits }: { credits: Credit[] }) {
  const { t, lang } = useLanguage();
  if (credits.length === 0) {
    return <p className="dealer-muted dealer-empty-row">{t('dealer.credits.empty')}</p>;
  }
  return (
    <div className="dealer-table-wrap">
      <table className="dealer-table">
        <thead>
          <tr>
            <th>{t('dealer.credits.buyer')}</th>
            <th>{t('dealer.credits.faceValue')}</th>
            <th>{t('dealer.credits.used')}</th>
            <th>{t('dealer.credits.remaining')}</th>
            <th>{t('dealer.credits.status')}</th>
            <th>{t('dealer.credits.expires')}</th>
          </tr>
        </thead>
        <tbody>
          {credits.map((c) => (
            <tr key={c.id}>
              <td>
                <div>{c.buyerName || t('dealer.credits.unnamed')}</div>
                <div className="dealer-muted" dir="ltr">{c.buyerPhone}</div>
                {!c.hasAccount && <div className="dealer-hint">{t('dealer.credits.noAccount')}</div>}
              </td>
              <td><Money value={c.faceValueAed} /></td>
              <td><Money value={c.usedAed} /></td>
              <td><Money value={c.remainingAed} /></td>
              <td><StatusChip status={c.status} /></td>
              <td>{formatDate(c.expiresAt, lang)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
